import { createNamedContext } from "./createNamedContext";
export { createNamedContext };
export default createNamedContext;
